import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import { Circle, Menu } from 'lucide-react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';

import Avatar from '../Avatar';

import UnreadThreadsQuery from '../Message/getUnreadThreads.graphql';

import s from './DropDownMenu.css';
class DropDownMenu extends React.Component {

  static propTypes = {
    allUnreadThreadsCount: PropTypes.shape({
      loading: PropTypes.bool,
      getUnreadCount: PropTypes.shape({
        total: PropTypes.number,
      }),
    }),
  };

  static defaultProps = {
    allUnreadThreadsCount: {
      loading: true,
      getUnreadCount: {
        total: 0,
      },
    },
  };

  render() {
    const { allUnreadThreadsCount: { loading, getUnreadCount }, homeHeaderOnly, layoutType, isVerified } = this.props;
    let count = 0;
    if (!loading && getUnreadCount != null) {
      count = getUnreadCount?.total != null ? getUnreadCount?.total : 0;
    }
    const isNewMessage = count > 0;

    return (
      <div className={s.menuBg}>
        {
          isVerified && isNewMessage && <Circle className={cx(s.notification, 'notificationHeaderRTL', 'homeNotifiction', 'homeNotifictionRTL')} size={8} fill="currentColor" />
        }
        <span className={s.menuIconWrapper}>
          <Menu size={20} className={cx(s.menuIcon, homeHeaderOnly && s.menuIconLight)} strokeWidth={2} />
        </span>
        <span>
          <Avatar
            isUser
            type={'small'}
            height={32}
            width={32}
            className={s.userAvatar}
          />
        </span>
      </div>
    );
  }
}

const mapState = state => ({
  layoutType: state?.siteSettings?.data?.homePageType
});

export default compose(
  withStyles(s),
  graphql(UnreadThreadsQuery, {
    name: 'allUnreadThreadsCount',
    options: {
      ssr: false,
      pollInterval: 60000,
    },
  }),
  (connect(mapState))
)(DropDownMenu);
